import {Plugins, Type} from '@packages/systems/wfdl';
import {
  EFunction,
  EUnion,
  ECase,
  EText,
  functionOf,
  TTypeReference,
  TText,
  TNumber,
  TUnion,
  Expression,
} from '@packages/systems/wfdl-ast';
import {$, _$, forall} from '@packages/utilities/wfdl-helpers';
import {TEffect, fail, pure} from '@packages/systems/plugins/Effect';
import {TEmail, parseEmail} from '@packages/systems/plugins/Email';
import {TLink, parseLink} from '@packages/systems/plugins/Link';
import {parseNumber} from '@packages/systems/plugins/Number';
import {True, False, TBoolean} from '@packages/systems/plugins-utils/Boolean';
import {concat, textEquals} from '@packages/systems/plugins/Text';

const errorTag = 'Form Field Parse Error';

const resultToEffectCases = {
  Error: EFunction({
    param: 'error',
    body: fail(EUnion({tag: errorTag, value: $('error')})),
  }),
  Ok: _$('Effect', 'pure'),
} as const;

const parserEnvType = (retTy: Type) => ({
  dataType: forall(
    ['other errors'],
    functionOf(
      TText,
      TEffect(
        TUnion({[errorTag]: TText}, TTypeReference('other errors')),
        retTy
      )
    )
  ),
  exported: 'visible',
});

const createParser = (
  resultParser: (arg: Expression) => Expression,
  retTy: Type
) => ({
  envType: parserEnvType(retTy),
  expression: EFunction({
    param: 'text',
    body: ECase({
      value: resultParser($('text')),
      cases: resultToEffectCases,
    }),
  }),
});

export const plugin = Plugins.PrivilegedPlugin({
  values: {
    // @ts-expect-error - TS2322 - Type '{ envType: { dataType: Type; exported: string; }; expression: ExpressionF<ExpressionF<any>>; }' is not assignable to type 'TypedValue'.
    'Expect Email': createParser(parseEmail, TEmail),
    // @ts-expect-error - TS2322 - Type '{ envType: { dataType: Type; exported: string; }; expression: ExpressionF<ExpressionF<any>>; }' is not assignable to type 'TypedValue'.
    'Expect Number': createParser(parseNumber, TNumber),
    // @ts-expect-error - TS2322 - Type '{ envType: { dataType: Type; exported: string; }; expression: ExpressionF<ExpressionF<any>>; }' is not assignable to type 'TypedValue'.
    'Expect Link': createParser(parseLink, TLink),
    'Expect Boolean': {
      // @ts-expect-error - TS2322 - Type '{ dataType: Type; exported: string; }' is not assignable to type 'EnvType'.
      envType: parserEnvType(TBoolean),
      expression: EFunction({
        param: 'text',
        body: ECase({
          value: textEquals($('text'), EText('true')),
          cases: {
            True: EFunction({param: '_', body: pure(True)}),
            False: EFunction({
              param: '_',
              body: ECase({
                value: textEquals($('text'), EText('false')),
                cases: {
                  True: EFunction({param: '_', body: pure(False)}),
                  False: EFunction({
                    param: '_',
                    body: fail(
                      EUnion({
                        tag: errorTag,
                        value: concat([
                          EText(
                            'Expected the text "true" or "false" but got "'
                          ),
                          $('text'),
                          EText('".'),
                        ]),
                      })
                    ),
                  }),
                },
              }),
            }),
          },
        }),
      }),
    },
  },
});
